import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import "../assets/styles/components/sliderSlick.scss"

class SliderSlick extends React.Component {
    constructor() {
        super();
        this.slider = React.createRef();
    }
  render() {
    const { children, settings } = this.props;

    return (
      <Slider {...settings} ref={this.slider}>
        { children }
      </Slider>
    );
  }
}

SliderSlick.defaultProps = {
  settings: {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
  }
}

SliderSlick.propTypes = {
  children: PropTypes.node,
  settings: PropTypes.object,
}

export default SliderSlick;
export { SliderSlick }
